import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ChatbotLinkBiData } from '../types';
import { getKbWidgetState, getRuntimeDataForBi } from '../utils';

export const logWixContactClickOnALinkInsideASolution: BiEventLogger<ChatbotLinkBiData> = async (
  state,
  { link, label },
) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  biLogger.wixContactClickOnALinkInsideASolution({
    action_url: link,
    link_url: link,
    link_name: label ?? undefined,
    kb_widget_state: getKbWidgetState(state),
    chatbot_view: contextBi?.chatbot_view,
    lang: locale,
    session_id: sessionId,
    conversation_id: biData.conversationId,
    node_id: biData.nodeId,
    main_option_name: biData.mainOptionName,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    user_experience: contextBi?.user_experience,
    context_iframeurllist: undefined,
    widget_view_mode: undefined,
    main_option_id: undefined,
    previous_node_id: undefined,
    referral_info: undefined,
    sub_option_id: undefined,
    call_center_status: undefined,
    estimated_wait_time: undefined,
    referral_name: undefined,
    solution_time: undefined,
    solution_title: undefined,
    sub_option_name: undefined,
    ticketing_status: undefined,
    suggestion_id: undefined,
    chatbot_state: undefined,
    ai_user_intent: undefined,
    ai_user_intent_type: undefined,
  });
};
